<!-- 客房详情组件模板 -->
<template class="ycf-component-item" id="componentRoomDetail">
  <div
    class="Layer-FullScreen component-room-detail"
    v-show="dialogRoomDetailShowed"
    :class="{ 'slide-bottom': dialogRoomDetailSlideBottom }"
    @click="hideDialogRoomDetail"
  >
    <div class="main-bottom" @click.stop>
      <!--产品名称-->
      <div class="head-title">
        {{ roomDetails.goodsName }}<i @click="hideDialogRoomDetail"></i>
      </div>

      <!--滚动区域-->
      <div class="body-scroll" :class="{ 'has-foot': showBottom }">
        <!--客房详情轮播图-->
        <div
          class="swiper-container room-detail"
          v-if="roomDetails.album && roomDetails.album.length"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              :key="index"
              v-for="(item, index) in roomDetails.album"
            >
              <img :src="item.imgUrl | filterImgLink" />
            </div>
          </div>
          <div
            class="picture-index"
            v-if="roomDetails.album && roomDetails.album.length > 1"
          >
            {{ bannerTag || 1 }}/{{
              roomDetails.album ? roomDetails.album.length : 1
            }}
          </div>
        </div>

        <!--房型信息-->
        <div
          class="room-info"
          v-if="
            roomDetails.baseInfo ||
            (roomDetails.facilities && roomDetails.facilities.length)
          "
        >
          <!--基础信息-->
          <div
            class="txt-h"
            v-if="roomDetails.baseInfo && roomDetails.baseInfo.length"
          >
            基础信息
          </div>
          <div
            class="row baseInfo-item"
            :class="{
              'bed-size': item.name == '床型尺寸' || item.name == '加床规则',
              'row-line': item.name == '加床规则' && roomDetails.noBreakfast,
            }"
            :key="index"
            v-for="(item, index) in roomDetails.baseInfo"
          >
            <span class="cel-1">{{ item.name }}</span>
            <span class="cel-2">：</span>
            <span class="cel-3">{{
              typeof item.size != "string" ||
              !item.size.replace(/[^0-9]/g, "") ||
              +item.size.replace(/[^0-9]/g, "")
                ? item.size
                : "-"
            }}</span>
          </div>
          <br />
          <!--房间设施-->
          <div
            class="txt-h"
            v-if="roomDetails.facilities && roomDetails.facilities.length"
          >
            房间设施
          </div>
          <div
            class="row facility"
            :key="facility.cateName"
            v-for="facility in roomDetails.facilities"
          >
            <span class="cel-1">{{ facility.cateName }}</span>
            <span class="cel-2">：</span>
            <span class="cel-3"
              ><span :key="item.name" v-for="item in facility.list">{{
                item.name
              }}</span></span
            >
          </div>
        </div>

        <!--购买须知-->
        <div class="book-notice" v-if="showBookNotice">
          <div class="txt-h">购买须知</div>
          <div class="row-rule" v-if="roomDetails.refundDesc">
            <span class="cel-1">{{
              roomDetails.refundDesc.changeRuleTitle
            }}</span>
            <span class="cel-2">
              <span
                :key="index"
                v-for="(rule, index) in roomDetails.refundDesc.changeRuleDetail"
                >{{ rule }}<br
              /></span>
            </span>
          </div>
          <div
            class="row-rule"
            v-if="
              roomDetails.refundDesc && roomDetails.refundDesc.overdueRefund
            "
          >
            <span class="cel-1">过期自动退</span>
            <span class="cel-2">
              <span
                :key="index"
                v-for="(rule, index) in roomDetails.refundDesc.overdueRefund"
                >{{ rule }}<br
              /></span>
            </span>
          </div>
          <div class="row-rule" v-if="roomDetails.orderRuleDesc">
            <span class="cel-1">{{ roomDetails.orderRuleDesc.title }}</span>
            <span class="cel-2">{{
              roomDetails.orderRuleDesc.description
            }}</span>
          </div>
          <div class="bookRoom-explanation">
            <p class="row-1">订房说明</p>
            <p class="row-2">
              {{
                roomDetails.isGlobalSale
                  ? "预约后请等待商家确认，预约结果请以确认短信为准"
                  : "支付成功后请等待商家确认，收到确认短信表示预订成功。如预订失败，已支付费用将全部原路退还，境内卡5个工作日内到账，境外卡20个工作日内到账"
              }}
            </p>
          </div>
          <div
            class="txt-p"
            v-html="roomDetails.bookNotice"
            v-if="roomDetails.bookNotice"
          ></div>
        </div>

        <!--已经到底了-->
        <div class="in-the-end">··<span>已经到底了</span>··</div>
      </div>

      <!--底部栏-->
      <div class="foot-bottom" v-if="showBottom">
        <div class="left-price">
          <p class="row-1">
            <span v-if="roomDetails.equalPrice">均</span><span>￥</span
            >{{ formatPrice(roomDetails.price) }}
          </p>
          <p class="row-2" v-if="roomDetails.oriPrice">
            门市价：￥{{ formatPrice(roomDetails.oriPrice) }}
          </p>
        </div>
        <div class="right-btn" :class="btnClass" @click="clickBtnBook">
          {{ btnText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/*客房详情组件
 *依赖插件swiper，需引用以下css和js
 * <link rel="stylesheet" href="//qiniu-cdn7.jinxidao.com/style/swiper.min.css">
 * <?php $this->partial("shared/libScript", array('script' => 'swiper.js'));?>
 *
 *  [showDialogRoomDetail(options) 传入参数，显示客房详情]
 * options: {
 *     weChatId:"421",//非必传，公众号id
 *     goodId: "15324",// 房型id
 *     skuId: "236", // 非必传，价格代码id
 *     title:"房型详情",// 非必传，弹框标题，默认“房型详情”
 *     showBookNotice:false, //非必传，是否显示预订须知，默认不显示
 *     showBottom: false,// 非必传，是否显示底部操作栏，默认不显示
 *     price: "499",// 非必传，价格
 *     oriPrice: "1299"// 非必传，门市价
 *     fn_book: function(){}, //非必传，预订按钮触发的方法
 *     btnText: "预订" // 非必传，底部按钮文案，默认“预订”文案
 *     btnClass: "",// 非必传，底部按钮额外样式，让预订按钮不可点击可传"disabled"
 *     isNeedSetHash:false, //非必传，是否需要设置hash值，默认false，若设置了hash，用户点击系统返回键或浏览器自带的返回按钮，可隐藏弹框
 * 	   equalPrice: false, //非必传，是否显示为均价
 * }
 *
 * [hideDialogRoomDetail() 无参，隐藏客房详情]
 */
import { toast, showLoading, hideLoading } from "@ykz/ykz-util/base";
import { addQiniuParams, previewImage } from "@ykz/ykz-util/platform";
import databus, { Origins } from "@ykz/ykz-http/core";

const YCF_Plugin = window.YCF_Plugin;
const Swiper = window.Swiper;
export default {
  name: "roomDetail",
  data: function () {
    return {
      title: "房型详情", //弹框标题
      roomDetails: {}, //房型信息对象
      dialogRoomDetailShowed: false, //是否显示弹框，默认false
      dialogRoomDetailSlideBottom: true, //是否弹框是否默认下滑，默认true
      showBottom: false, //是否显示底部固定栏，默认不显示
      fn_book: function () {}, //通过参数传递过来的点击“预订”按钮触发的方法,
      btnClass: "", //预订按钮样式类名
      btnText: "", //预订按钮文案
      showBookNotice: false, //是否显示预订须知，默认不显示
      bannerTag: 1, //轮播图index
      albumUrl: [], // 需要预览的图片http链接列表
      isAPP: window.mobileEnv == "app" ? true : false, //是否在云客赞app打开页面
    };
  },
  porps: {
    roomDetailsSlideDown: {},
  },
  watch: {
    dialogRoomDetailSlideBottom: function (val) {
      this.$emit("update:roomDetailsSlideDown", val);
    },
  },
  filters: {
    //图片链接增加七牛图片处理参数
    filterImgLink: function (value) {
      return addQiniuParams(
        value,
        "?imageView2/1/w/750/h/422/interlace/1/q/85/",
        "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_422.png"
      );
    },
  },
  mounted: function () {
    typeof window.componentCenter == "object" || (window.componentCenter = {});
    window.componentCenter.roomDetail = this;
    console.log("ycf组件初始化：room_detail");
    document.body.appendChild(this.$el); // 解决 酒景页被批量分享覆盖问题
  },
  beforeDestroy() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    //调用"/apiv2/room/getRoomDetail"接口获取详情数据，若与上次传入的goodId和skuId相同，则无需再调用接口，直接向上滑动显示房型详情弹框
    showDialogRoomDetail: function (options) {
      var that = this;
      options = options || {};
      options.skuId = options.skuId || "";
      options.goodId = options.goodId || "";
      that.title = options.title || "房型详情";
      that.fn_book = options.fn_book || function () {};
      that.btnClass = options.btnClass || "";
      that.btnText = options.btnText || "预订";
      that.isNeedSetHash = options.isNeedSetHash || false;
      that.showBookNotice = options.showBookNotice || false;

      //若传入goodId或skuId与记录的一样，则不需要重新调接口
      if (that.skuId == options.skuId && that.goodId == options.goodId) {
        //songdanhua edit: 兼容酒景价格会变的问题
        if (options.showBottom) {
          that.roomDetails.price = options.price;
          that.roomDetails.equalPrice = options.equalPrice || false;
        }
        that.slideUpDialog();
        return false;
      }
      var data = {
        goodId: options.goodId,
        skuId: options.skuId,
      };
      if (options.weChatId) {
        data.weChatId = options.weChatId;
      }
      databus({
        type: "get",
        url: "/apiv2/room/getRoomDetail",
        data: data,
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100 && res.content) {
            var tempObj = res.content || {},
              baseInfo = res.content.baseInfo || {};
            tempObj.baseInfo = [];
            if (baseInfo.area) {
              tempObj.baseInfo.push({
                name: "房间面积",
                size: baseInfo.area,
              });
            }
            if (baseInfo.bedType) {
              tempObj.baseInfo.push({
                name: "床型",
                size: baseInfo.bedType,
              });
            }
            if (baseInfo.bedSize) {
              tempObj.baseInfo.push({
                name: "床型尺寸",
                size: baseInfo.bedSize,
              });
            }
            if (baseInfo.hasWindow) {
              tempObj.baseInfo.push({
                name: "窗户",
                size: baseInfo.hasWindow == 1 ? "有窗" : "无窗",
              });
            }
            if (baseInfo.floor) {
              tempObj.baseInfo.push({
                name: "楼层",
                size: baseInfo.floor + "F",
              });
            }
            if (baseInfo.maxOccupancy) {
              tempObj.baseInfo.push({
                name: "可住人数",
                size: (function () {
                  if (baseInfo.maxOccupancy == -1) {
                    return "不限";
                  } else if (baseInfo.maxOccupancy > 30) {
                    return "可住30人以上";
                  } else {
                    return "可住" + baseInfo.maxOccupancy + "人";
                  }
                })(),
              });
            }
            if (baseInfo.extraBedRules) {
              tempObj.baseInfo.push({
                name: "加床规则",
                size: baseInfo.extraBedRules,
              });
            }
            if (baseInfo.breakfastStr && baseInfo.showBreakfast) {
              tempObj.baseInfo.push({
                name: "早餐",
                size: baseInfo.breakfastStr,
              });
            } else {
              tempObj.noBreakfast = true;
            }
            that.roomDetails = tempObj;
            if (options.showBottom) {
              that.roomDetails.price = options.price;
              that.roomDetails.oriPrice = options.oriPrice;
              that.roomDetails.equalPrice = options.equalPrice || false;
              that.showBottom = options.showBottom;
            }
            that.goodId = options.goodId || "";
            that.skuId = options.skuId || "";

            initBanner();
          } else {
            hideLoading();
            toast(res.message || "网络异常");
          }
        },
        error: function () {
          hideLoading();
          toast("网络异常");
        },
        beforeSend: function () {
          showLoading({
            cover: true,
            opacity: 0,
          });
        },
      });

      //轮播图
      function initBanner() {
        if (that.mySwiper) {
          that.mySwiper.destroy(true, true); //新建Swiper对象，需要销毁旧的Swiper对象
          that.mySwiper = null;
          $(".component-room-detail .body-scroll").unbind("scroll");
        }
        if (!that.roomDetails.album || !that.roomDetails.album.length) {
          that.roomDetails.album = [];
          // that.roomDetails.album.push({
          // 	imgUrl: ""
          // });
        }

        for (var i in that.roomDetails.album) {
          that.albumUrl[i] = that.roomDetails.album[i].imgUrl;
          if (i > 0) {
            that.roomDetails.album[i].imgUrl =
              "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_422.png";
          }
        }

        var length = that.roomDetails.album.length;
        that.$nextTick(function () {
          if (length <= 1) {
            openPreviewImage();
            hideLoading();
            that.slideUpDialog(); //相册少于2张,不轮播
            return;
          }

          var slideIndex = 0;
          that.mySwiper = new Swiper(".swiper-container.room-detail", {
            autoplay: 5000, //可选选项，自动滑动
            loop: true,
            autoplayDisableOnInteraction: false, //是否在用户操作后还可继续自动滑动
            width: window.innerWidth,
            onSlideChangeEnd: function (swiper) {
              that.bannerTag = swiper.activeIndex % length;
              if (that.bannerTag == 0) {
                that.bannerTag = length;
              }
              if (swiper.activeIndex > 0) {
                slideIndex = (swiper.activeIndex - 1) % length;
              } else {
                slideIndex = length - 1;
              }
              if (
                that.roomDetails.album[that.bannerTag - 1] &&
                that.roomDetails.album[that.bannerTag - 1].imgUrl &&
                that.roomDetails.album[that.bannerTag - 1].imgUrl.search(
                  "loading_img_750_422.png"
                ) != -1
              ) {
                that.roomDetails.album[that.bannerTag - 1].imgUrl =
                  that.albumUrl[that.bannerTag - 1];
                $(
                  ".swiper-container.room-detail .swiper-slide[data-swiper-slide-index='" +
                    slideIndex +
                    "'] img"
                ).each(function () {
                  this.src = returnImgLink(that.albumUrl[that.bannerTag - 1]);
                });
              }

              //延迟2秒，预加载下一张轮播图
              if (
                that.roomDetails.album[that.bannerTag] &&
                that.roomDetails.album[that.bannerTag].imgUrl
              ) {
                if (
                  that.roomDetails.album[that.bannerTag].imgUrl.search(
                    "loading_img_750_422.png"
                  ) != -1
                ) {
                  setTimeout(function () {
                    if (that.bannerTag >= length) {
                      return;
                    }
                    that.roomDetails.album[that.bannerTag].imgUrl =
                      that.albumUrl[that.bannerTag];
                    $(
                      ".swiper-container.room-detail .swiper-slide[data-swiper-slide-index='" +
                        (slideIndex + 1) +
                        "'] img"
                    ).each(function () {
                      this.src = returnImgLink(that.albumUrl[that.bannerTag]);
                    });
                  }, 2000);
                }
              }
            },
          });
          openPreviewImage();
          hideLoading();
          that.slideUpDialog();

          //离开可视区域,停止轮播
          $(".component-room-detail .body-scroll").scroll(function () {
            if (
              $(this).get(0).scrollTop >=
              $(".swiper-container.room-detail")[0].offsetHeight
            ) {
              that.mySwiper.autoplaying && that.mySwiper.stopAutoplay();
            } else {
              !that.mySwiper.autoplaying && that.mySwiper.startAutoplay();
            }
          });
        });
      }

      //返回处理好的图片链接
      function returnImgLink(value) {
        return addQiniuParams(
          value,
          "?imageView2/1/w/750/h/422/interlace/1/q/85/",
          "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_422.png"
        );
      }

      //打开微信自带的图片预览
      function openPreviewImage() {
        if (that.isAPP) {
          return false;
        }
        $(".swiper-container.room-detail .swiper-slide>img").unbind("click");
        $(".swiper-container.room-detail .swiper-slide>img").click(function (
          event
        ) {
          var imgUrl = event.target.src;
          if (typeof imgUrl != "string") {
            return false;
          } else {
            imgUrl = imgUrl.split("?")[0];
          }
          console.log(imgUrl);
          if (
            imgUrl &&
            imgUrl.search("loading_img_750_422.png") == -1 &&
            that.albumUrl.length > 0
          ) {
            previewImage({
              current: imgUrl, // 当前显示图片的http链接
              urls: that.albumUrl, // 需要预览的图片http链接列表
            });
          }
        });
      }
    },

    //向上滑动显示房型详情弹框
    slideUpDialog: function () {
      var that = this;
      that.dialogRoomDetailShowed = true;
      setTimeout(function () {
        that.dialogRoomDetailSlideBottom = false;
        if (that.isNeedSetHash) {
          that.setHash("roomDetails");
        }
        if (
          that.mySwiper &&
          $(".component-room-detail .body-scroll")[0].scrollTop <
            $(".swiper-container.room-detail")[0].offsetHeight
        ) {
          that.mySwiper.startAutoplay();
        }
      }, 30);
    },

    //向下滑动隐藏房型详情弹框
    hideDialogRoomDetail: function () {
      var that = this;
      that.dialogRoomDetailSlideBottom = true;
      setTimeout(function () {
        that.dialogRoomDetailShowed = false;
        location.hash == "#roomDetails" && history.go(-1);
        that.mySwiper &&
          that.mySwiper.autoplaying &&
          that.mySwiper.stopAutoplay();
      }, 300);
    },

    //点击预订按钮
    clickBtnBook: function () {
      if (this.btnClass == "disabled") {
        return false;
      }
      this.fn_book();
    },

    //设置hash值
    setHash: function (str) {
      if (location.hash.replace("#", "") != str) {
        location.hash = str;
      }
    },

    //格式化价格
    formatPrice: function (price) {
      if (!price) {
        return "-";
      } else {
        return (+price).toFixed(2);
      }
    },
  },
};
</script>

<style lang="scss">
.component-room-detail {
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 0;
  i {
    font-style: normal;
  }
  &.slide-bottom {
    .main-bottom {
      transform: translateY(100%);
    }
  }
  .main-bottom {
    transition: transform 0.3s;
    position: absolute;
    background-color: #fff;
    width: 100%;
    bottom: 0;
    left: 0;
    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: -env(safe-area-inset-bottom);
      left: 0;
      width: 100%;
      height: env(safe-area-inset-bottom);
      background-color: #fff; /* 让安全区域也变白 */
    }
    .head-title {
      position: relative;
      padding-left: pxToRem(32);
      padding-right: pxToRem(32+30);
      line-height: pxToRem(90);
      font-size: pxToRem(30);
      color: rgba(51, 51, 51, 1);
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      i {
        position: absolute;
        right: pxToRem(32);
        top: 50%;
        transform: translateY(-50%);
        line-height: pxToRem(30);
        &::after {
          content: "\e644";
          font-size: pxToRem(24);
          color: rgba(51, 51, 51, 0.5);
          font-family: "iconfont" !important;
          font-weight: normal;
        }
      }
    }
    .body-scroll {
      height: pxToRem(975-90);
      overflow-x: hidden;
      overflow-y: auto;
      &.has-foot {
        height: pxToRem(975-90-110);
      }
      .swiper-container.room-detail {
        height: pxToRem(422);
        line-height: pxToRem(422);
        img {
          width: 100%;
          vertical-align: middle;
        }
        .picture-index {
          position: absolute;
          z-index: 1;
          left: 50%;
          transform: translateX(-50%);
          bottom: pxToRem(16);
          background-color: rgba(51, 51, 51, 0.32);
          width: pxToRem(108);
          line-height: pxToRem(50);
          border-radius: pxToRem(25);
          font-size: pxToRem(28);
          color: rgb(255, 255, 255);
          text-align: center;
        }
      }
      .room-info {
        padding: 0 pxToRem(32);
        .txt-h {
          line-height: 1;
          color: rgb(51, 51, 51);
          font-size: pxToRem(26);
          margin: pxToRem(47-6) 0 pxToRem(18-6);
          &:first-of-type {
            margin-top: pxToRem(32);
          }
        }
        .row {
          vertical-align: top;
          line-height: pxToRem(38);
          color: rgb(145, 145, 145);
          span {
            display: inline-block;
            font-size: pxToRem(26);
            vertical-align: top;
          }
          .cel-1 {
            width: pxToRem(115);
            text-align: justify;
            overflow-y: hidden;
            height: pxToRem(38);
            &::after {
              content: "";
              width: 100%;
              display: inline-block;
            }
          }
          .cel-2 {
            width: pxToRem(35);
          }
          .cel-3 {
            width: pxToRem(536);
          }
        }
        .baseInfo-item {
          display: inline-block;
          width: 50%;
          .cel-3 {
            width: pxToRem(193);
          }
          &.bed-size {
            padding-right: pxToRem(5);
            .cel-3 {
              display: inline;
              word-break: break-all;
            }
          }
          &.row-line {
            width: 100%;
          }
        }
        .facility .cel-3 span {
          margin-right: pxToRem(45);
        }
      }
      .book-notice {
        padding: pxToRem(32-6) pxToRem(32) 0;
        .txt-h {
          line-height: 1;
          color: rgb(51, 51, 51);
          font-size: pxToRem(26);
        }
        .row-rule {
          margin-top: pxToRem(10);
          &:first-of-type {
            margin-top: pxToRem(22-6);
          }
          .cel-1 {
            display: inline-block;
            vertical-align: middle;
            min-width: pxToRem(86);
            padding: 0 pxToRem(12);
            height: pxToRem(30);
            line-height: pxToRem(30);
            background: rgba(255, 241, 232, 1);
            border: pxToRem(1.5) solid rgba(255, 212, 189, 1);
            border-radius: pxToRem(4);
            font-size: pxToRem(22);
            color: rgba(255, 113, 36, 1);
            text-align: center;
            margin-right: pxToRem(20);
          }
          .cel-2 {
            vertical-align: middle;
            font-size: pxToRem(26);
            color: rgba(51, 51, 51, 1);
            line-height: pxToRem(39);
          }
        }
        .bookRoom-explanation {
          margin-top: pxToRem(40-6);
          .row-1 {
            line-height: 1;
            font-size: pxToRem(28);
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          }
          .row-2 {
            margin-top: pxToRem(24-6);
            font-size: pxToRem(26);
            color: rgba(88, 88, 88, 1);
            line-height: pxToRem(39);
          }
        }
        .txt-p {
          padding-top: pxToRem(40-6);
          padding-bottom: pxToRem(30);
          font-size: pxToRem(26);
          color: rgba(51, 51, 51, 1);
        }
      }
      .in-the-end {
        padding: pxToRem(72-6) 0 pxToRem(99);
        line-height: 1;
        text-align: center;
        font-size: pxToRem(30);
        color: rgba(229, 231, 233, 1);
        span {
          font-size: pxToRem(26);
          margin: 0 pxToRem(10);
          color: rgba(204, 204, 204, 1);
        }
      }
    }
    .foot-bottom {
      position: relative;
      line-height: pxToRem(110);
      height: pxToRem(110);
      background-color: #fff;
      box-shadow: 0 pxToRem(-2) pxToRem(5) rgba(0, 0, 0, 0.08);
      .left-price {
        display: inline-block;
        margin-left: pxToRem(24);
        line-height: 1;
        vertical-align: middle;
        .row-1 {
          font-size: pxToRem(36);
          color: rgb(255, 113, 36);
          font-weight: bold;
          span {
            font-size: pxToRem(24);
          }
        }
        .row-2 {
          font-size: pxToRem(24);
          margin-top: pxToRem(12);
          color: rgb(153, 153, 153);
          text-decoration: line-through;
        }
      }
      .right-btn {
        position: absolute;
        right: pxToRem(24);
        top: 50%;
        transform: translateY(-50%);
        width: pxToRem(276);
        line-height: pxToRem(84);
        height: pxToRem(84);
        border-radius: pxToRem(90);
        background: linear-gradient(
          137deg,
          rgba(255, 135, 46, 1) 0%,
          rgba(255, 103, 46, 1) 100%
        );
        font-size: pxToRem(34);
        color: rgba(255, 255, 255, 1);
        font-weight: bold;
        text-align: center;
        &.disabled {
          background-image: none;
          background-color: rgb(204, 204, 204);
        }
      }
    }
  }
}
</style>
